module.exports = __webpack_public_path__ + "static/media/info_icon_bulk.8026e841.svg";